/**
 * 账单/余额静态演示数据（不走接口）
 */

/** 6月份大模型消耗总费用 */
export const JUNE_MODEL_CONSUMPTION = 120000

export const JUNE_MODEL_CONSUMPTION_DISPLAY = '120,000.00'

/** @deprecated 兼容旧引用，等同 JUNE_MODEL_CONSUMPTION */
export const TOTAL_MODEL_CONSUMPTION = JUNE_MODEL_CONSUMPTION

/** @deprecated 兼容旧引用 */
export const TOTAL_MODEL_CONSUMPTION_DISPLAY = JUNE_MODEL_CONSUMPTION_DISPLAY

/** 账户余额 */
export const ACCOUNT_BALANCE = '0.00'

export const ACCOUNT_BALANCE_RAW = 0

/** 金融类大模型名称（仅用于展示） */
export const FINANCIAL_MODEL_NAME = 'FinSight-融汇金融大模型'

export const MOCK_USER_INFO = {
  name: 'admin',
  username: 'admin',
  balance: ACCOUNT_BALANCE
}

const DAILY_BILL_VARIATIONS = [
  28.5, -15.2, 42.8, -8.6, 19.3, -22.1, 11.4, -5.7, 33.6, -18.9,
  24.2, -12.4, 38.1, -9.3, 16.7, -25.8, 7.5, -14.6, 31.2, -20.3,
  26.8, -11.1, 36.4, -7.9, 14.5, -23.6, 9.8, -16.2, 29.7, -6.4,
  18.6, -19.8, 12.3, -10.5, 27.9, -13.7, 21.1, -8.2, 34.5, -17.3
]

function formatDate(date) {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

function formatMoney(amount) {
  return Number(amount).toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

/** 生成 6 月 1 日～6 月 28 日每日账单，合计 ¥120,000.00 */
function buildDailyBillingList() {
  const dates = []
  const current = new Date(2026, 5, 1)
  const end = new Date(2026, 5, 28)

  while (current <= end) {
    dates.push(new Date(current))
    current.setDate(current.getDate() + 1)
  }

  const dayCount = dates.length
  const base = JUNE_MODEL_CONSUMPTION / dayCount
  const costs = []
  let sum = 0

  for (let i = 0; i < dayCount - 1; i++) {
    const cost = Math.round((base + DAILY_BILL_VARIATIONS[i % DAILY_BILL_VARIATIONS.length]) * 100) / 100
    costs.push(cost)
    sum += cost
  }
  costs.push(Number((JUNE_MODEL_CONSUMPTION - sum).toFixed(2)))

  return dates.map((date, index) => {
    const dateStr = formatDate(date)
    const compactDate = dateStr.replace(/-/g, '')
    const bill = {
      billId: `BILL-${compactDate}01`,
      product: '大模型推理',
      resource: FINANCIAL_MODEL_NAME,
      specification: '80B · Token按量',
      billingType: '按量计费',
      startTime: `${dateStr} 00:00:00`,
      endTime: `${dateStr} 23:59:59`,
      cost: costs[index],
      status: 'paid'
    }
    if (index === dayCount - 1) {
      bill.remark = `6月28日推理额度已消耗完毕，6月份消耗 ¥${JUNE_MODEL_CONSUMPTION_DISPLAY}，请充值后继续使用`
    }
    return bill
  })
}

/** 账单明细（6 月 1 日～6 月 28 日每日推理账单，合计 ¥120,000.00） */
export const billingDetailList = buildDailyBillingList()

export const LAST_DAY_COST = billingDetailList[billingDetailList.length - 1].cost

export const LAST_DAY_COST_DISPLAY = formatMoney(LAST_DAY_COST)

export const billingOverviewStats = [
  {
    title: '6月消耗',
    value: JUNE_MODEL_CONSUMPTION_DISPLAY,
    icon: 'el-icon-wallet',
    color: '#409eff',
    change: null
  },
  {
    title: '本月费用',
    value: JUNE_MODEL_CONSUMPTION_DISPLAY,
    icon: 'el-icon-data-line',
    color: '#67c23a',
    change: null
  },
  {
    title: '昨日费用',
    value: LAST_DAY_COST_DISPLAY,
    icon: 'el-icon-data-analysis',
    color: '#e6a23c',
    change: null
  },
  {
    title: '账户余额',
    value: ACCOUNT_BALANCE,
    icon: 'el-icon-money',
    color: '#f56c6c',
    change: null
  }
]

export const productCostList = [
  {
    product: '大模型推理',
    resource: FINANCIAL_MODEL_NAME,
    count: 1,
    monthCost: JUNE_MODEL_CONSUMPTION_DISPLAY,
    yesterdayCost: LAST_DAY_COST_DISPLAY,
    todayCost: '0.00',
    trend: 0
  }
]

export const unpaidBills = []

export const costAlerts = [
  {
    id: 1,
    title: '余额已用尽',
    type: 'error',
    description: `${FINANCIAL_MODEL_NAME} 6月份消耗 ¥${JUNE_MODEL_CONSUMPTION_DISPLAY}，当前账户余额 ¥${ACCOUNT_BALANCE}`
  },
  {
    id: 2,
    title: '大模型月结提醒',
    type: 'warning',
    description: `6月28日最后一笔日账单已扣款，6月份消耗 ¥${JUNE_MODEL_CONSUMPTION_DISPLAY}，推理额度已全部消耗完毕`
  }
]

/** 费用趋势图数据（近 30 条日账单） */
export function getBillingTrendData(limit = 30) {
  return [...billingDetailList]
    .sort((a, b) => new Date(a.endTime.replace(/-/g, '/')) - new Date(b.endTime.replace(/-/g, '/')))
    .slice(-limit)
    .map(item => ({
      date: item.endTime.slice(5, 10).replace('-', '/'),
      cost: item.cost
    }))
}

export const topConsumptionResources = [
  { name: FINANCIAL_MODEL_NAME, type: '大模型推理', cost: JUNE_MODEL_CONSUMPTION },
  { name: 'web-server-01', type: '云服务器', cost: 1280.00 },
  { name: 'web-server-02', type: '云服务器', cost: 1280.00 },
  { name: 'prod-mysql-01', type: '云数据库', cost: 960.00 },
  { name: 'db-server-01', type: '云服务器', cost: 920.00 },
  { name: 'prod-redis-01', type: '云数据库', cost: 680.00 },
  { name: 'my-website-assets', type: '对象存储', cost: 485.60 },
  { name: 'app-backup', type: '对象存储', cost: 512.40 },
  { name: 'web-lb-01', type: '负载均衡', cost: 280.00 },
  { name: 'api-lb-01', type: '负载均衡', cost: 260.00 }
]

export const pieChartData = [
  { value: JUNE_MODEL_CONSUMPTION, name: '大模型推理' }
]

/** 充值记录（静态演示） */
export const rechargeListMock = [
  {
    id: 1,
    orderId: 'RCH-2026060101',
    payAmount: JUNE_MODEL_CONSUMPTION_DISPLAY,
    payType: 'alipay',
    status: 1,
    createDate: '2026-06-01 09:30:00',
    remark: 'FinSight 6月模型服务充值'
  },
  {
    id: 2,
    orderId: 'RCH-2026062901',
    payAmount: '50,000.00',
    payType: 'wechatpay',
    status: 0,
    createDate: '2026-06-29 14:20:00',
    remark: '6月额度用尽后续费充值（待支付）'
  }
]

/** 发票管理（静态演示） */
export const invoiceListMock = [
  {
    id: 'INV-2026062801',
    type: 'normal',
    title: 'hnzt',
    taxNumber: '91110000MA01234567',
    amount: JUNE_MODEL_CONSUMPTION_DISPLAY,
    status: 'pending',
    applyTime: '2026-06-28 16:30:00',
    issueTime: '-'
  }
]

/** 消费分析 TOP 资源（静态演示） */
export const analysisTopResources = [
  { name: FINANCIAL_MODEL_NAME, type: '大模型推理', cost: JUNE_MODEL_CONSUMPTION }
]

export function filterRechargeList(list, searchForm = {}) {
  return list.filter(item => {
    if (searchForm.orderId && !item.orderId.includes(searchForm.orderId)) {
      return false
    }
    if (searchForm.payType && item.payType !== searchForm.payType) {
      return false
    }
    if (searchForm.status !== '' && searchForm.status !== null && searchForm.status !== undefined) {
      if (String(item.status) !== String(searchForm.status)) {
        return false
      }
    }
    return true
  })
}

export function filterInvoiceList(list, searchForm = {}) {
  return list.filter(item => {
    if (searchForm.type && item.type !== searchForm.type) {
      return false
    }
    if (searchForm.status && item.status !== searchForm.status) {
      return false
    }
    return true
  })
}

export function updateAccountBalance(amount) {
  const balance = Number(amount).toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
  localStorage.setItem('accountBalance', balance)
  return balance
}

export function initAccountBalanceStorage() {
  localStorage.setItem('accountBalance', ACCOUNT_BALANCE)
}
